export default {"src":"/_next/static/image/public/assets/icons/bulb.52facb876c89b734cf3bbc6ff512b4fa.svg","height":24,"width":24};